
/* ==========================================
   LIÈVRE RUNNING — PRODUCT INTEGRATION
   Shopify Dawn
   ========================================== */

(function () {
  'use strict';

  const SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL'];

  function initializeProduct(block) {
    if (block.dataset.lievreInitialized === 'true') return;

    const productInfo = block.closest('product-info');
    if (!productInfo) return;

    const customPrice = block.querySelector(
      '[data-custom-product-price]'
    );

    const sizePicker = block.querySelector(
      '[data-lievre-size-picker]'
    );

    if (!customPrice) return;

    /* -------------------- */
    /* Shopify Live Price */
    /* -------------------- */

    function findNativePrice() {
      return Array.from(
        productInfo.querySelectorAll('[id^="price-"]')
      ).find(element =>
        !element.closest('[data-custom-product-price]')
      );
    }

    let nativePrice = findNativePrice();

    function updatePrice() {
      nativePrice = findNativePrice();
      if (!nativePrice) return;

      const html = nativePrice.innerHTML;

      if (customPrice.innerHTML !== html) {
        customPrice.innerHTML = html;
      }

      nativePrice.style.display = 'none';
    }

    updatePrice();

    /* -------------------- */
    /* Shopify Size Controls */
    /* -------------------- */

    function getSizeControl() {
      const controls = Array.from(
        productInfo.querySelectorAll(
          'variant-selects select, ' +
          'variant-selects fieldset, ' +
          'variant-radios fieldset'
        )
      );

      return controls.find(control => {
        const wrapper = control.closest('.product-form__input');

        const label = wrapper?.querySelector(
          '.form__label, legend, label'
        );

        const name = (
          control.getAttribute('name') ||
          label?.textContent ||
          ''
        ).toLowerCase();

        return name.includes('size') ||
               name.includes('taille');
      }) || (controls.length === 1 ? controls[0] : null);
    }

    /* -------------------- */
    /* Read Current Sizes */
    /* -------------------- */

    function getSizeOptions(control) {
      if (!control) return [];

      if (control.tagName === 'SELECT') {
        return Array.from(control.options).map(option => ({
          label: option.value.trim(),
          selected: option.selected,
          available: !option.disabled,
          element: option
        }));
      }

      return Array.from(
        control.querySelectorAll('input[type="radio"]')
      ).map(input => ({
        label: input.value.trim(),
        selected: input.checked,
        available:
          !input.disabled &&
          !input.classList.contains('disabled') &&
          !input.closest('label')?.classList.contains('disabled'),
        element: input
      }));
    }

    /* -------------------- */
    /* Update Button States */
    /* -------------------- */

    function updateButtonStates() {
      if (!sizePicker) return;

      const control = getSizeControl();
      if (!control) return;

      const options = getSizeOptions(control);

      sizePicker.querySelectorAll(
        '.lievre-size-button'
      ).forEach(button => {
        const option = options.find(item =>
          item.label.toUpperCase() ===
          button.textContent.trim().toUpperCase()
        );

        if (!option) return;

        button.classList.toggle(
          'is-selected',
          option.selected
        );

        button.classList.toggle(
          'is-unavailable',
          !option.available
        );

        button.disabled = !option.available;

        button.setAttribute(
          'aria-pressed',
          String(option.selected)
        );
      });
    }

    /* -------------------- */
    /* Custom Size Picker */
    /* -------------------- */

    function renderSizes() {
      if (!sizePicker) return;

      const control = getSizeControl();
      if (!control) return;

      const options = getSizeOptions(control)
        .filter(option =>
          SIZE_ORDER.includes(
            option.label.toUpperCase()
          )
        )
        .sort((a, b) =>
          SIZE_ORDER.indexOf(a.label.toUpperCase()) -
          SIZE_ORDER.indexOf(b.label.toUpperCase())
        );

      if (!options.length) return;

      // Avoid rebuilding buttons unnecessarily.
      const existingSizes = Array.from(
        sizePicker.querySelectorAll('.lievre-size-button')
      ).map(button =>
        button.textContent.trim().toUpperCase()
      );

      const newSizes = options.map(option =>
        option.label.toUpperCase()
      );

      if (
        existingSizes.length === newSizes.length &&
        existingSizes.every(
          (size, index) => size === newSizes[index]
        )
      ) {
        updateButtonStates();
        return;
      }

      sizePicker.innerHTML = '';

      options.forEach(option => {
        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'lievre-size-button';
        button.textContent = option.label;

        button.setAttribute(
          'aria-label',
          'Size ' + option.label
        );

        /* -------------------- */
        /* Size Click Handling */
        /* -------------------- */

        button.addEventListener('click', () => {
          if (button.disabled) return;

          // Always use the current Shopify controls.
          const currentControl = getSizeControl();

          if (!currentControl) return;

          if (currentControl.tagName === 'SELECT') {
            currentControl.value = option.label;

            currentControl.dispatchEvent(
              new Event('change', {
                bubbles: true
              })
            );
          } else {
            const currentInput = Array.from(
              currentControl.querySelectorAll(
                'input[type="radio"]'
              )
            ).find(input =>
              input.value.trim().toUpperCase() ===
              option.label.toUpperCase()
            );

            if (!currentInput) return;

            currentInput.click();
          }

          // Reflect the native selection without
          // destroying and recreating the buttons.
          requestAnimationFrame(updateButtonStates);
        });

        sizePicker.appendChild(button);
      });

      updateButtonStates();
    }

    /* -------------------- */
    /* Initialize Sizes */
    /* -------------------- */

    renderSizes();

    /* -------------------- */
    /* Live Price Updates */
    /* -------------------- */

    let priceObserver = null;

    function observeNativePrice() {
      const currentPrice = findNativePrice();

      if (!currentPrice) return;

      if (priceObserver) {
        priceObserver.disconnect();
      }

      priceObserver = new MutationObserver(() => {
        updatePrice();
      });

      priceObserver.observe(currentPrice, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    observeNativePrice();

    /* -------------------- */
    /* Variant Synchronization */
    /* -------------------- */

    productInfo.addEventListener('change', event => {
      if (
        event.target.closest(
          'variant-selects, variant-radios'
        )
      ) {
        requestAnimationFrame(() => {
          renderSizes();
          updatePrice();
        });
      }
    });

    /* -------------------- */
    /* Handle Dawn DOM Updates */
    /* -------------------- */

    let variantRefreshScheduled = false;

    const variantObserver = new MutationObserver(() => {
      if (variantRefreshScheduled) return;

      variantRefreshScheduled = true;

      requestAnimationFrame(() => {
        variantRefreshScheduled = false;

        renderSizes();
        updatePrice();
      });
    });

    const variantContainer = productInfo.querySelector(
      'variant-selects, variant-radios'
    );

    if (variantContainer) {
      variantObserver.observe(variantContainer, {
        childList: true,
        subtree: true
      });
    }

    block.dataset.lievreInitialized = 'true';
  }

  /* -------------------- */
  /* Initialize All Products */
  /* -------------------- */

  function initializeAllProducts() {
    document.querySelectorAll(
      '.product-block'
    ).forEach(initializeProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllProducts
    );
  } else {
    initializeAllProducts();
  }

  /* -------------------- */
  /* Shopify Theme Editor */
  /* -------------------- */

  document.addEventListener(
    'shopify:section:load',
    initializeAllProducts
  );

})();
